<template>
<div>
    <div class="content" style="width:auto">
        <div class="cont-list">
            <span class="list">{{ this.parentRoute.menuName }}-{{ title }}生产厂家</span>
        </div>

        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <div class="edit-card">
                <div style="width:88%;display: flex">
                    <div class="start-label" />
                    <span class="text">生产厂家基础信息</span>
                </div>
                <div >
                    <el-row>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="生产厂家编号" prop="no">
                                <el-input disabled v-model="form.no" placeholder="系统自动生成生产厂家编号" style="width:90%"></el-input>
                            </el-form-item>
                             <span class="viewText" v-else>生产厂家编号: {{ form.no }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="生产厂家名称" prop="name">
                                <el-input v-model="form.name" :disabled="!editMode" placeholder="请填写生产厂家名称" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>生产厂家名称: {{ form.name }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="生产厂家级别" prop="level">
                                <el-select v-model="form.level" :disabled="!editMode" placeholder="请选择级别" style="width: 90%;">
                                    <el-option v-for="item in LevelOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else>生产厂家级别: {{ form.level }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="生产厂家类型" prop="category">
                                <el-select v-model="form.category" :disabled="!editMode" multiple placeholder="请选择类型" style="width: 90%;">
                                    <el-option v-for="item in ManufacturerCategoryOptions" :key="item.id" :label="item.name + '厂商'" :value="item.name + '厂商'"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else>生产厂家类型: {{ form.category.join(',') }}</span>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="联系人" prop="contactor">
                                <el-input v-model="form.contactor" :disabled="!editMode" placeholder="请填写联系人" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>联系人: {{ form.contactor }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="联系方式" prop="phone">
                                <el-input v-model="form.phone" :disabled="!editMode" placeholder="请填写联系方式" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>联系方式: {{ form.phone }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="产地信息" prop="countryId">
                                <Address style="width:90%" :disabled="!editMode" :oldCountryId="form.countryId" :oldProvinceId="form.provinceId" :oldCityId="form.cityId" @change="getAddressData"></Address>
                            </el-form-item>
                            <span class="viewText" v-else>产地信息: {{ form.countryId }}</span>
                        </el-col>

                    

                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="详细地址" prop="address">
                                <el-input v-model="form.address" :disabled="!editMode" placeholder="请填写详细地址" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>详细地址: {{ form.address }}</span>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="组织机构代码" prop="creditCode">
                                <el-input v-model="form.creditCode" :disabled="!editMode" placeholder="请填写组织机构代码" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>组织机构代码: {{ form.creditCode }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="开户银行" prop="openBank">
                                <el-input v-model="form.openBank" :disabled="!editMode" placeholder="请填写开户账号" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>开户银行: {{ form.openBank }}</span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="开户账号" prop="bankAccount">
                                <el-input v-model="form.bankAccount" :disabled="!editMode" placeholder="请填写开户账号" style="width:90%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>开户账号: {{ form.bankAccount }}</span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" prop="productionRangeName" label="生产范围">
                                <el-select v-model="form.productionRangeName" :disabled="!editMode" value-key="id" multiple placeholder="请选择生产范围" filterable :filter-method="getProductionRanges" @change="rangeChange" style="width:100%">
                                    <el-option v-for="item in STATIC_ProductionRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else>生产范围: {{ form.productionRangeName.join(',') }}</span>
                        </el-col>
                        <el-col :span="12" :class="!getIsView()?'viewCol':''">
                            <el-form-item v-if="getIsView()" label="备注" prop="remark">
                                <el-input v-model="form.remark" :disabled="!editMode" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>备注: {{ form.remark }}</span>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div class="edit-card" style="margin-top:10px;padding-bottom:10px">
                <div style="width:88%;display: flex">
                    <div class="start-label" />
                    <span class="text">生产厂家证件信息</span>
                </div>

                <div v-if="editMode" style="margin:20px 0 12px 10px">
                    <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                    <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
                </div>

                <!-- <el-table ref="childTable" border :data="form.details" style="width: auto;margin: 0 10px;" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                    <el-table-column type="selection" fixed width="50" align="center" />
                    <el-table-column label="证件类型" align="center" width="180" prop="category">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.category" :disabled="!editMode" style="width: 100%" filterable placeholder="请选择证件类型">
                                <el-option v-for="item in ManufacturerCertificateOptions" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="证件编码" align="center" width="150" prop="no">
                        <template slot-scope="scope">
                            <el-input placeholder="请填写证件编码" :disabled="!editMode" v-model="scope.row.no"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="证件名称" align="center" width="150" prop="name">
                        <template slot-scope="scope">
                            <el-input placeholder="请填写证件名称" :disabled="!editMode" v-model="scope.row.name"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="证件生效日期" align="center" width="160" prop="startDate">
                        <template slot-scope="scope">
                            <el-date-picker v-model="scope.row.startDate" :disabled="!editMode" style="width: 100%" type="date" @change="dateChange(scope.row)" value-format="yyyy-MM-dd" placeholder="选择日期">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column label="证件失效日期" align="center" width="230" prop="endDate">
                        <template slot-scope="scope">
                            <div style="display:flex;align-items: center;justify-content: center;">
                                <el-date-picker v-model="scope.row.endDate" :disabled="!editMode" style="width: 80%" type="date" @change="dateChange(scope.row)" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="{
                      disabledDate(v) {
                        return endDateDisabledDate(v, scope.row);
                      },
                    }">
                                </el-date-picker>
                                <el-button class="btn default" size="small" :disabled="!editMode" style="margin-left:5px;width:40px;min-width: 60px;" v-preventReClick @click="changeEndDate(scope.row)">永久</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="上传附件" width="300px" align="center">
                        <template slot-scope="scope">
                            <div style="display:flex;align-items:center;">
                                <el-upload style="width:50%" class="upload-demo" :disabled="!editMode" ref="upload" :multiple="true" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                      (response, file, fileList) =>
                        onUploadSuccess(
                          response,
                          file,
                          fileList,
                          scope.row,
                          scope
                        )
                    ">
                                    <el-button type="text">点击此处上传附件</el-button>
                                </el-upload>
                                <el-popover style="width:50%" placement="bottom" width="360" trigger="click">
                                    <ul class="fileListUl_always" :key="'ul' + timeStamp">
                                        <li class="fileItem" v-for="(item, index) in scope.row.fileInfos" :key="index">
                                            <span class="fileName">{{ item.name }}</span>
                                            <div class="btn_group canedit">
                                                <span v-preventReClick @click="privewImg(item)">
                                                    点击查看
                                                </span>
                                                <span v-preventReClick @click="downloadImg(item)">
                                                    下载
                                                </span>
                                                <span v-preventReClick v-if="editMode" @click="RemoveFile(item, scope.row)">
                                                    删除
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                    <span slot="reference" class="show-files">
                                        查看附件
                                        <i class="el-icon-caret-top"></i>
                                    </span>
                                </el-popover>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="证书状态" align="center" width="100" prop="stateName">
                        <template slot-scope="scope">
                            <span :class="{
                    enable: scope.row.stateName != '过期',
                    forbidden: scope.row.stateName == '过期',
                  }">{{ scope.row.stateName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="200">
                        <template slot-scope="scope">
                            <el-input :disabled="!editMode" v-model="scope.row.remark"></el-input>
                        </template>
                    </el-table-column>
                </el-table> -->

                <el-tabs v-model="activeName">
                    <el-tab-pane label="其它供应商维护" name="1">
                        <el-table :data="form.updateDetails" :row-class-name="tableRowClassName" border height="400" style="width: auto;margin: 0 10px;" stripe :header-cell-style="{ background: '#DDEBFF' }">
                            <el-table-column label="序号" width="50" fixed="left" align="center" type="index" />
                            <el-table-column label="证件名称" width="180" align="center" prop="name" />

                            <el-table-column label="证件编号" width="180" align="center" prop="no" />
                            <el-table-column label="证件类型" width="180" align="center" prop="categoryName" />
                            <el-table-column label="生效日期" align="center" width="150" prop="startDate">
                                <template slot-scope="scope">
                                    <span>{{
                    parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
                  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="失效日期" align="center" width="150" prop="endDate">
                                <template slot-scope="scope">
                                    <span>{{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="效期状态" align="center" width="80" prop="overdueName"></el-table-column>
                            <el-table-column width="180" label="证件扫描件">
                                <template slot-scope="scope">
                                    <div v-for="file in scope.row.fileInfos" :key="file.id">
                                        <el-button type="text" size="medium" @click.stop="privewImg(file)">{{file.name}}</el-button>
                                        <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="审批状态" width="180" align="center" prop="approveStateName" />
                            <el-table-column label="启用状态" align="center" width="80">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.state == 0 ? "否" : "是" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="拒绝原因" width="180" align="center" prop="reason" />
                            <el-table-column label="上传单位" align="center" width="120" prop="uploadSupplierName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="上传时间" align="center" width="120">
                                <template slot-scope="scope">
                                    <span>{{
                    scope.row.uploadTime ? parseTime(new Date(scope.row.uploadTime)) : ""
                  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" align="center" prop="reason" />
                            <el-table-column label="操作" fixed="right" align="center" width="150" class-name="small-padding fixed-width">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.approveState == 0" size="mini" type="text" @click="approveEvt(scope.row)">审批</el-button>
                                    <el-button size="mini" type="text" @click="DeleEvt(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="其它供应商" name="2">
                        <el-table :data="form.details" border height="400" style="width: auto;margin: 0 10px;" stripe :header-cell-style="{ background: '#DDEBFF' }">
                            <el-table-column label="序号" width="50" fixed="left" align="center" type="index" />
                            <el-table-column label="证件名称" width="180" align="center" prop="name" />

                            <el-table-column label="证件编号" width="180" align="center" prop="no" />
                            <el-table-column label="证件类型" width="180" align="center" prop="categoryName" />
                            <el-table-column label="生效日期" align="center" width="150" prop="startDate">
                                <template slot-scope="scope">
                                    <span>{{
                    parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
                  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="失效日期" align="center" width="150" prop="endDate">
                                <template slot-scope="scope">
                                    <span>{{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column width="180" label="证件扫描件">
                                <template slot-scope="scope">
                                    <div v-for="file in scope.row.fileInfos" :key="file.id">
                                        <el-button type="text" size="medium" @click.stop="privewImg(file)">{{file.name}}</el-button>
                                        <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="效期状态" align="center" width="80" prop="overdueName"></el-table-column>

                            <el-table-column label="启用状态" align="center" width="80">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.state == 0 ? "否" : "是" }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否换新证" width="100" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.isNew == 1 ? "是" : "否" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="上传单位" align="center" width="120" prop="uploadSupplierName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="上传时间" align="center" width="120">
                                <template slot-scope="scope">
                                    <span>{{
                    scope.row.uploadTime ? parseTime(new Date(scope.row.uploadTime)) : ""
                  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" align="center" prop="remark" />
                            <el-table-column label="操作" fixed="right" align="center" width="180" :key="'mySuppliersOperate'" class-name="small-padding fixed-width">
                                <template slot-scope="scope">
                                    <!-- <el-button v-if="!scope.row.uploadSupplierName &&title !== '查看'" size="mini" type="text" @click="DeactivateEvt(scope.row)">停用</el-button> -->
                                    <el-button size="mini" type="text" @click="DeleEvt(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                </el-tabs>

            </div>

            <el-form-item label="启用状态">
                <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
                </el-switch>
                <span v-if="form.state">已启用</span>
                <span v-else>已禁用</span>
            </el-form-item>
        </el-form>
        <!-- <div slot="footer" class="dialog-footer footer-bottom" style="margin-left: 35%; ">
        <el-button class="btn" size="small" v-preventReClick
            @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick
            @click="submit">确 定</el-button>
      </div> -->

        <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
        <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button class="btn primary" type="primary" v-if="editMode" v-preventReClick @click="submit">确 定</my-button>
    </div>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
</div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
    GetManufacturerById,
    SaveManufacturer,
    UpdateManufacturerApproveStateById,
    RemoveManufacturerDetails
} from "@/api";
import {
    ManufacturerCategoryOptions,
    LevelOptions,
    ManufacturerCertificateOptions,
} from "@/enum";
import Address from "@/components/address";
import MyUpload from "@/components/my-upload";
import ElImageViewer from "@/components/elImageViewer";

export default {
    name: "manufacturerEdit",
    mixins: [GetDataMixin],
    components: {
        Address,
        MyUpload,
        ElImageViewer,
    },
    data() {
        return {
            title: "",
            form: {},
            // 生产厂家证件类型
            ManufacturerCertificateOptions: ManufacturerCertificateOptions,
            ManufacturerCategoryOptions: ManufacturerCategoryOptions,
            LevelOptions: LevelOptions,
            rules: {
              sourceType:[{ required: true, message: "请选择模块", trigger: "blur" }],
                name: [{
                    required: true,
                    message: "厂商名称不能为空",
                    trigger: "blur"
                }, ],
                category: [{
                    required: true,
                    message: "厂商类型不能为空",
                    trigger: "blur"
                }, ],
                creditCode: [{
                    required: true,
                    message: "社会信用代码不能为空",
                    trigger: "blur"
                }, ],
                contactor: [{
                    required: true,
                    message: "联系人不能为空",
                    trigger: "blur"
                }, ],
                phone: [{
                        required: true,
                        message: "联系电话不能为空",
                        trigger: "blur"
                    },
                    // {
                    //   pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                    //   message: "请输入正确的手机号码",
                    //   trigger: "blur",
                    // },
                ],
                productionRangeName: [{
                    required: true,
                    message: '请选择生产范围',
                    trigger: 'blur'
                }],
            },
     
            // 子表
            childIds: [],
            childMultipleSelection: [],
            childMultiple: true,
            // fileId: 0,
            // fileName: '',
            // openViewer: false,
            countryId: "",
            provinceId: "",
            cityId: "",
            dialogVisible: false,
            dialogImageUrl: "",
            fileName: "",
            fileId: 0,
            timeStamp: "",
            editMode: false,
            activeName: '1',
        };
    },
    props: {
        // title: {
        //   type: String,
        //   default () {
        //     return ''
        //   }
        // }
    },
    created() {
        var query = this.$route.query;
        
        if (query.id) {
            this.handleUpdate(query.id);
        } else {
            this.handleAdd();
        }

        this.getProductionRanges('')
    },
    methods: {
        // 新建
        handleAdd() {
            this.title = "新建";
            this.resetForm();
            this.editMode = true;
        },
        // 编辑
        handleUpdate(id) {
            GetManufacturerById({
                id
            }).then((res) => {
                this.resetForm()
                this.form = res.returnData;
                this.countryId = this.form.countryId;
                this.provinceId = this.form.provinceId;
                this.cityId = this.form.cityId;
                this.title = "编辑";
                this.form.category = this.form.category.split(';')
                this.form.details.forEach((e, index) => {
                    e.$index = index + 1;
                });

                if (this.form.productionRangeInfos) {
                    let arr = this.form.productionRangeInfos.map(item => {
                        var range = this.STATIC_ProductionRanges.filter(e => e.id == item.id)
                        if (!range || range.length == 0) {
                            this.STATIC_ProductionRanges.push(item)
                        }

                        return item.id * 1
                    })
                    this.$set(this.form, 'productionRangeName', [...arr])
                }

                this.editMode = false;
                if (this.formMode == 2) {
                    this.editMode = true;
                }
                console.log("2")
            });
        },
        // 保存
        submit() {
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.form.countryId = this.countryId || 0;
                this.form.provinceId = this.provinceId || 0;
                this.form.cityId = this.cityId || 0;

                this.form.category = this.form.category.join(';')

                SaveManufacturer(this.form).then((res) => {
                        this.$my_message(`执行成功`, "success");
                        sessionStorage.setItem("editMode", 0);
                        // this.$router.push({ path: this.getMainPath(this.$route.path) });
                        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
                    })
                    .finally(() => {
                        this.form.category = this.form.category.split(';')
                    });
            });
        },
        resetForm() {
            this.form = {
                name: "",
                state: 1,
                countryId: 0,
                provinceId: 0,
                cityId: 0,
                details: [],
                productionRangeName: [],
                productionRangeId: '',
                orgCode :sessionStorage.getItem('orgId'),
            };
        },
        // 取消编辑
        cancel() {
            // this.$my_confirm("确认要中断当前操作吗？", "提示", {
            //   type: "warning",
            // }).then(() => {
            //   });
            // this.$router.push({ path: this.getMainPath(this.$route.path) });
            this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        },
        handleAddChildForm() {
            if (!this.form.details) this.form.details = [];
            this.$nextTick(() => {
                this.form.details.push({
                    $index: this.form.details.length + 1,
                    id: 0,
                    categoryName: "",
                    fileInfos: [],
                    stateName: "",
                    no: "",
                    category: 1,
                    certificateName: "",
                    startDate: "",
                    endDate: "",
                    files: "",
                    remark: "",
                });
            });
        },
        handleDeleteChildForm() {
            this.form.details = this.form.details.filter(
                (i) => !this.childIds.includes(i.$index)
            );
            this.form.details.forEach((e, index) => {
                e.$index = index + 1;
            });
        },
        handleChildSelectionChange(selection) {
            this.childMultipleSelection = selection;
            this.childIds = selection.map((item) => item.$index);
            this.childMultiple = !selection.length;
        },
        changeEndDate(row) {
            row.endDate = "2099-12-31";
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            if (this.$route.query.detailId) {
                console.log(123, row.id, this.$route.query.detailId);
                if (row.id == this.$route.query.detailId) {
                    return 'warning-row';
                }
            }

        },
        rangeChange(val) {
            this.form['productionRangeId'] = val ? val.join(';') : ''
        },
        dateChange(row) {
            if (row.startDate && row.endDate) {
                // if (
                //   new Date(row.startDate) < new Date() &&
                //   new Date(row.endDate) >= new Date()
                // ) {
                //   row.stateName = "正常";
                // } else {
                //   row.stateName = "过期";
                // }
                if (new Date(row.endDate) < new Date()) {
                    row.stateName = "过期";
                } else {
                    row.stateName = "正常";
                }
            }
        },
        getAddressData(countryId, provinceId, cityId) {
            this.countryId = countryId;
            this.provinceId = provinceId;
            this.cityId = cityId;
        },

        // 上传附件
        filesChange(fileList, row) {
            row.fileInfos = fileList;
        },
        onUploadSuccess(response, file, fileList, row, scope) {
            response.returnData.forEach((item) => {
                // this.$set(this.form.details[scope.$index], "fileInfos", [item]);
                // row.fileInfos = [item];
                if (row.fileInfos.indexOf(item) == -1) {
                    row.fileInfos.push(item);
                }
            });
            this.timeStamp = new Date().valueOf();
        },
        privewImg(file) {
            // this.dialogImageUrl = file.path;
            // this.dialogVisible = true;
            this.dialogVisible = true;
            this.fileId = file.id;
            this.fileName = file.name;
        },
        closeImageViewer() {
            this.dialogVisible = false;
        },
        RemoveFile(file, row) {
            var index = row.fileInfos.indexOf(file);
            if (index > -1) {
                row.fileInfos.splice(index, 1);
            }
        },
        endDateDisabledDate(v, row) {
            if (row.startDate) {
                return v.getTime() < new Date(row.startDate).getTime();
            } else {
                return false;
            }
        },
        //

        approveEvt(row) {
            this.$prompt("请输入拒绝理由", "审批", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '拒绝',
                    confirmButtonClass: 'refuse',
                    cancelButtonClass: 'pass',
                    cancelButtonText: '通过',
                })
                .then(({
                    value
                }) => {
                    UpdateManufacturerApproveStateById({
                        id: row.id,
                        state: 4,
                        refuse: value,
                    }).then((res) => {
                        this.handleUpdate(this.form.id);
                    });
                })
                .catch((action, value) => {
                    console.log(this.$prompt.inputValue);
                    if (action == "cancel") {
                        UpdateManufacturerApproveStateById({
                            id: row.id,
                            state: 3,
                        }).then((res) => {
                            this.handleUpdate(this.form.id);
                        });
                    } else {
                        return;
                    }
                });
        },
        DeleEvt(row) {
            this.$confirm("删除后将无法恢复，请谨慎操作。", "确定要删除吗?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    RemoveManufacturerDetails({
                        ids: [row.id]
                    }).then((res) => {
                        this.handleUpdate(this.form.id);
                    });
                })
                .then(() => {
                    this.msgSuccess("删除成功");
                })
                .catch(function () {});
        },
    },

};
</script>

<style lang="scss" scoped>
  /deep/.el-table .warning-row {
    background: oldlace;
  }
</style>
